import { render } from "./AttrItem.vue?vue&type=template&id=043c9bb7"
import script from "./AttrItem.vue?vue&type=script&lang=ts"
export * from "./AttrItem.vue?vue&type=script&lang=ts"
script.render = render

export default script